import { render, staticRenderFns } from "./addContact.vue?vue&type=template&id=6aab3cd6"
import script from "./addContact.vue?vue&type=script&lang=js"
export * from "./addContact.vue?vue&type=script&lang=js"
import style0 from "./addContact.vue?vue&type=style&index=0&id=6aab3cd6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports